import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 36vw;
  min-width: 480px;
  max-width: 760px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  box-sizing: border-box;
  padding: 2.2vh 1.5vw 2.2vh 1.5vw;
  overflow-y: auto;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 0 1vh 0;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const SubText = styled.p`
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 400;
  margin: 0 0 1vh 0;
`

export const ListItem = styled.li`
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0.4vh;
`

export const SuccessText = styled.span`
  color: green;
`

export const ErrorText = styled.span`
  color: red;
`

export const ProgressContainer = styled.div`
  height: 18px;
  background-color: grey;
  margin: 1.2vh 0 2vh 0;
  width: 100%;
  max-width: 100%;
  border-radius: 2vw;
`

export const ProgressFill = styled.div`
  height: 18px;
  background-color: #6ec1e4;
  border-radius: 2vw;
`

export const ButtonsDiv = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  margin-top: 2vh;
  gap: 0.8vw;
`

export const FinishButton = styled.button`
  width: 8vw;
  min-width: 96px;
  height: 5.2vh;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 0;
  border: 1px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;
`

export const SecondaryButton = styled.button`
  width: 8vw;
  min-width: 96px;
  height: 5.2vh;
  background-color: #fff;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 0;
  border: 1px #c4c4c4 solid;
  border-radius: 3vw;
  cursor: pointer;

  &:hover {
    background-color: #f4f4f4;
  }
`

export const DisabledFinishButton = styled.button`
  width: 8vw;
  min-width: 96px;
  height: 5.2vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 0;
  border: 0;
  border-radius: 3vw;
  cursor: not-allowed;
`

export const ErrorBox = styled.div`
  background-color: #fde8e8;
  border: 1px solid #f98080;
  color: #9b1c1c;
  border-radius: 0.6vw;
  padding: 1.2vh 1vw;
  margin: 1.5vh 0;
  font-family: 'Inter', sans-serif;
  font-size: 0.95vw;
  line-height: 1.4;
  word-break: break-word;
  max-height: 25vh;
  overflow-y: auto;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5vh 0 1.5vh 0;
  width: 100%;
`

export const LoadingBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5vw;
  background-color: #f0f9ff;
  border: 1px solid #b9e6fe;
  color: #026aa2;
  border-radius: 2vw;
  padding: 0.6vh 1vw;
  font-family: 'Inter', sans-serif;
  font-size: 0.85vw;
  font-weight: 500;
  margin-top: 1.5vh;
`

export const LogSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.6vw;
  padding: 1.2vh 1vw;
  margin-top: 1.5vh;
  box-sizing: border-box;
`

export const LogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1vh;
  gap: 0.5vw;
`

export const LogTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 0.9vw;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.4vw;
`

export const LogTabs = styled.div`
  display: flex;
  gap: 0.4vw;
`

export const LogTab = styled.button<{ $active: boolean; $type: 'error' | 'updated' }>`
  display: inline-flex;
  align-items: center;
  gap: 0.3vw;
  padding: 0.4vh 0.7vw;
  border-radius: 2vw;
  font-family: 'Inter', sans-serif;
  font-size: 0.8vw;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;

  ${({ $active, $type }) =>
    $type === 'error'
      ? $active
        ? css`
            background-color: #fee2e2;
            border-color: #f87171;
            color: #991b1b;
          `
        : css`
            background-color: #fff;
            border-color: #e2e8f0;
            color: #64748b;
            &:hover {
              background-color: #fef2f2;
              color: #991b1b;
            }
          `
      : $active
      ? css`
          background-color: #e0f2fe;
          border-color: #38bdf8;
          color: #0369a1;
        `
      : css`
          background-color: #fff;
          border-color: #e2e8f0;
          color: #64748b;
          &:hover {
            background-color: #f0f9ff;
            color: #0369a1;
          }
        `}
`

export const LogList = styled.div`
  max-height: 18vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.6vh;
  padding-right: 0.3vw;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`

export const LogCard = styled.div<{ $type: 'error' | 'updated' }>`
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 4px solid ${({ $type }) => ($type === 'error' ? '#ef4444' : '#0284c7')};
  border-radius: 6px;
  padding: 0.7vh 0.8vw;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`

export const LogCardTop = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4vw;
  font-family: 'Inter', sans-serif;
  font-size: 0.8vw;
`

export const LogBadge = styled.span`
  background-color: #f1f5f9;
  color: #334155;
  font-weight: 700;
  padding: 0.2vh 0.4vw;
  border-radius: 4px;
  font-size: 0.75vw;
`

export const LogCode = styled.span`
  background-color: #f8fafc;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  font-family: monospace;
  font-weight: 600;
  padding: 0.15vh 0.35vw;
  border-radius: 4px;
  font-size: 0.75vw;
`

export const LogItemName = styled.span`
  color: #475569;
  font-weight: 500;
  font-size: 0.8vw;
  max-width: 25vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LogReason = styled.div`
  margin-top: 0.4vh;
  font-family: 'Inter', sans-serif;
  font-size: 0.8vw;
  color: #b91c1c;
  line-height: 1.35;
  word-break: break-word;
`

export const LogSuccessMessage = styled.div`
  margin-top: 0.4vh;
  font-family: 'Inter', sans-serif;
  font-size: 0.8vw;
  color: #0369a1;
  line-height: 1.35;
`

export const LogEmpty = styled.div`
  text-align: center;
  color: #94a3b8;
  font-family: 'Inter', sans-serif;
  font-size: 0.85vw;
  padding: 1.5vh 0;
`

